// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorMessage_container__2VHiC","placeholderShimmer":"ErrorMessage_placeholderShimmer__1Hv2S"};